import { useEffect } from "react";
import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography, Skeleton } from '@albo-ui/core';
import { FormControl, TextField } from '@mui/material';
import { useUpdateCard } from './hooks/useUpdateCard';

export type UpdateCardDialogProps = {
    onConfirm: (data) => void;
    onClose: () => void;
    open: boolean;
    title: string;
    message: string;
    data: any;
    type: string;
} & DefaultComponentProps;

export const UpdateCard = ({ open, title, message, data, type, onConfirm, onClose }: UpdateCardDialogProps) => {
    const { onHandleChange, form, error, isValid, loader } = useUpdateCard(open, data)
    
    useEffect(() => {}, [loader]);
    
    return (
        <Dialog onClose={onClose} open={open}>
            <DialogTitle>
                <Typography variant='h2'>{title}</Typography>
            </DialogTitle>
            {loader ? 
                <Skeleton width='100%' height='100px' style={{marginTop: 20}} />
                :    
                <DialogContent>
                    {type === 'deadline' && 
                        <FlexGrid container spacing={5} fullWidth direction='column'>
                            <FlexGrid item>
                                <Typography variant='paragraph'>{message}</Typography>
                            </FlexGrid>
                            <FlexGrid item>
                                <FormControl color='secondary' sx={{width: 200}}>
                                <TextField
                                    value={form['reimbursement_deadline'].slice(0,10)}
                                    onChange={onHandleChange.bind(this)}
                                    label='Fecha'
                                    size='small'
                                    type={'date'}
                                    error={error !== ''}
                                    helperText={error ? error : ''}
                                    InputLabelProps={{ shrink: true }}
                                    
                                />
                                </FormControl>
                            </FlexGrid>
                        </FlexGrid>
                    }
                    {type === 'billed' && 
                        <FlexGrid fullWidth>
                            <Typography variant='paragraph'>{message}</Typography>
                        </FlexGrid>
                    }
                    {type === 'download' && 
                        <FlexGrid container spacing={5} fullWidth direction='column'>
                            <FlexGrid item>
                                <Typography variant='paragraph'>{message}</Typography>
                            </FlexGrid>
                            <FlexGrid item>
                                <FormControl color='secondary' sx={{width: 200}}>
                                <TextField
                                    value={form['reimbursement_deadline'].slice(0,10)}
                                    onChange={onHandleChange.bind(this)}
                                    label='Mes'
                                    size='small'
                                    type={'date'}
                                    error={error !== ''}
                                    helperText={error ? error : ''}
                                    InputLabelProps={{ shrink: true }}
                                    
                                />
                                </FormControl>
                            </FlexGrid>
                        </FlexGrid>
                    }
                
                </DialogContent>
            }

            <DialogActions>
                <FlexGrid fullHeight justify='space-between' alignItems='flex-end' style={{ marginTop: '20px', display: 'flex' }}>
                    {type !== 'download' && 
                        <FlexGrid item>
                            <Button onClick={onClose} buttonType='secondary' size='normal' style={{width: 150}}>
                                Cancelar
                            </Button>
                        </FlexGrid>
                    }
                    <FlexGrid item style={{marginLeft: 15}}>
                        <Button disabled={isValid} onClick={() => onConfirm(form)} size='normal' style={{width: 150}}>
                        {type !== 'download' ? 'Aceptar' : 'Descargar'}
                        </Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    )
}